// removed by extract-text-webpack-plugin
module.exports = {"catalog-card":"catalog-card___I3lEY","card-body":"card-body___1a_gB","left":"left___2wvJ6","cover-lots":"cover-lots___1oden","middle":"middle___1sx99","title":"title___3anX5","description":"description___1YddN","right":"right___1WMpx","start-date":"start-date___zA11c","live-link-container":"live-link-container___2KA_W","live":"live___3bJZS","explore":"explore___2yNM5","register-link":"register-link___2q9Bg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CatalogCard/HorizontalCatalogCard.scss
// module id = z0Eu
// module chunks = 46